import ReactRailsUJS from "react_ujs";
import ServerList from "./components/ServerList";
import ClassicServerList from "./components/ClassicServerList";

ReactRailsUJS.useContext({
    ServerList,
    ClassicServerList,
});
